import { Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";

import LwcErrorBoundary from "../../../components/LwcErrorBoundary";

const iconStyle = {
	width: "24px"
};

const CourseSidebarItem = ({ Icon, children, description, title }) => (
	<LwcErrorBoundary>
		<Row className="mb-3">
			<Col xs="auto">
				{Icon
					? <Icon className="fs-16 text-blue" style={iconStyle} /> : <div style={iconStyle} />}
			</Col>

			<Col>
				{title
					? (
						<h6 className="mt-1 mb-2 text-neutral3 text-uppercase fs-16">
							{title}
						</h6>) : null}

				{ !!description && (
					typeof description === "function"
						? description()
						: typeof description === "string"
							? (<p>
								{description}
							</p>)
							: description
				)}

				{children}
			</Col>
		</Row>
	</LwcErrorBoundary>
);

CourseSidebarItem.propTypes = {
	Icon: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.func]),
	children: PropTypes.arrayOf(PropTypes.element),
	description: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
	title: PropTypes.string
};

CourseSidebarItem.defaultProps = {
	Icon: null,
	children: null,
	description: null,
	title: null
};

export default CourseSidebarItem;
